import { motion } from "framer-motion";
import { SectionEyebrow } from "@/components/Marquee";

const VERBS = [
  { label: "Choose", tier: "Drona" },
  { label: "Negotiate", tier: "Arjuna" },
  { label: "Protect", tier: "Bhishma" },
];

export default function USPBanner() {
  return (
    <section id="usp" className="relative py-24 md:py-32 bg-void" data-testid="usp-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. I" testId="usp-eyebrow">The Difference</SectionEyebrow>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
          data-testid="usp-headline"
        >
          You choose the car. <span className="italic gradient-text">We negotiate the deal.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="mt-6 text-lg md:text-xl text-silver/75 max-w-2xl leading-relaxed"
          data-testid="usp-subheadline"
        >
          Most car-buying services help you research, compare or inspect. CaarSaarthi goes one step further —
          we negotiate directly with the dealership on your behalf.
        </motion.p>

        <div className="mt-14 flex flex-wrap items-center gap-4 md:gap-6" data-testid="usp-verbs">
          {VERBS.map((v, i) => (
            <motion.div
              key={v.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.8, 0, 0.2, 1] }}
              className="flex items-center gap-4 md:gap-6"
            >
              <div className="rounded-2xl border border-white/10 bg-surface px-6 py-4 md:px-8 md:py-5">
                <p className="font-serif text-2xl md:text-3xl text-white">{v.label}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-silver/50">{v.tier}</p>
              </div>
              {i < VERBS.length - 1 && (
                <span className="font-serif text-2xl md:text-3xl text-white/25 hidden sm:block">→</span>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
